import React from 'react';
import { Helmet } from 'react-helmet-async';

const DEFAULT_TITLE = 'Physign - Book Doctors, Nurses & Home Healthcare in India';
const DEFAULT_DESCRIPTION = 'Book verified doctors, nurses, and home healthcare in minutes. Trusted by thousands across India.';
const DEFAULT_OG_IMAGE = 'https://customer-assets.emergentagent.com/job_4bf5f59f-ff2a-4b89-ab5f-09ffb3b85c36/artifacts/91dqnx5f_high-resolution-color-logo-3.png';
const BASE_URL = 'https://physign.com';

export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '',
  image = DEFAULT_OG_IMAGE,
  noindex = false,
  schema = null,
}) {
  const fullTitle = title ? title + ' | Physign' : DEFAULT_TITLE;
  const url = BASE_URL + (path || '');
  const desc = description || DEFAULT_DESCRIPTION;
  const img = image || DEFAULT_OG_IMAGE;

  return (
    <Helmet
      title={fullTitle}
      link={[{ rel: 'canonical', href: url }]}
      meta={[
        { name: 'description', content: desc },
        ...(noindex ? [{ name: 'robots', content: 'noindex, nofollow' }] : []),
        { property: 'og:title', content: fullTitle },
        { property: 'og:description', content: desc },
        { property: 'og:url', content: url },
        { property: 'og:image', content: img },
        { name: 'twitter:title', content: fullTitle },
        { name: 'twitter:description', content: desc },
        { name: 'twitter:image', content: img },
      ]}
      script={schema ? [{ type: 'application/ld+json', innerHTML: JSON.stringify(schema) }] : []}
    />
  );
}
